export const PASSWORD_ERROR = 'La contraseña introducida no coincide con el correo electrónico.';
export const USER_ERROR = 'Este usuario no está activo, para solicitar acceso favor contactar con soporte@thynkads.com.';
export const USER_PENDING_ERROR = 'Este usuario está pendiente de aprobacion, para solicitar acceso favor contactar con soporte@thynkads.com.';
